import {Table, Form, Space, Radio, Badge, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import LoanCheck from './LoanCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './loan.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import LoanEditReportEdit from './LoanEditReportEdit';
import LoanEdit from './LoanEdit';
function LoanListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "jk_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => ((item.jk_state === '2' || item.jk_state === '3' || item.jk_state === '4' || item.jk_state === '5' || item.jk_state === '6') && item.jk_uid === props.yh_id) && item.jk_uid === props.yh_id);      
            if(query.jk_state){
                if(query.jk_state === '5'){
                arr = arr.filter((item) => item.jk_state === '5' || item.jk_state === '6');
                }else{
                arr = arr.filter((item) => item.jk_state === query.jk_state);
                }
            }      
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.jk_id
            }));
            const unread = arr.filter(item => item.jk_state === '5');
            const read = arr.filter(item => item.jk_state === '2' || item.jk_state === '3' || item.jk_state === '4' || item.jk_state === '6');
            read.sort((a, b) => new Date(b.jk_state_time) - new Date(a.jk_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.list, query.jk_state, props.yh_id])
    
    const columns = [    
        {
            title: '借款人',
            dataIndex: 'jk_kh_name',
            width: '12%',
            key: 'jk_kh_name',         
            render: (text, record) =>{
                if(record.jk_state === '4'){
                    if(record.jk_bzd_id){
                            return <LoanEditReportEdit
                                jk_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                jk_bzd_id={record.jk_bzd_id}
                                jk_bzd_name={record.jk_bzd_name}
                                jk_kh_id={record.jk_kh_id}
                                jk_kh_name={record.jk_kh_name}
                                jk_state={record.jk_state}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                            />
                        }else{
                            return <LoanEdit
                                jk_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                jk_bzd_id={record.jk_bzd_id}
                                jk_bzd_name={record.jk_bzd_name}
                                jk_kh_id={record.jk_kh_id}
                                jk_kh_name={record.jk_kh_name}
                                jk_state={record.jk_state}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                            />
                        }
                    
                    }else{
                        return <LoanCheck
                                        type='button'
                                        jk_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        jk_bzd_id={record.jk_bzd_id}
                                        jk_price={record.jk_price}
                                        jk_content={record.jk_content}
                                        jk_date={record.jk_date}
                                        jk_date_end={record.jk_date_end}
                                        jk_bzd_name={record.jk_bzd_name}
                                        jk_bzd_danhao={record.jk_bzd_danhao}
                                        jk_type_id={record.jk_type_id}
                                        jk_type_name={record.jk_type_name}
                                        jk_kh_id={record.jk_kh_id}
                                        jk_kh_name={record.jk_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        jk_num={record.jk_num}
                                        jk_amount={record.jk_amount}
                                        jk_state={record.jk_state}
                                        jk_bm_id={record.jk_bm_id}
                                        jk_bm_name={record.jk_bm_name}
                                        jk_khyhzh_id={record.jk_khyhzh_id}
                                        jk_khyhzh_name={record.jk_khyhzh_name}
                                        jk_image_name={record.jk_image_name}
                                        jk_image_file={record.jk_image_file}
                                        jk_ctime={record.jk_ctime}
                                        jk_uid={record.jk_uid}
                                        listType='submitted'
                                    />
              }
           }
        },
        {
            title: '借款金额',
            dataIndex: 'jk_amount',
            width: '10%',
            key: 'jk_amount',   
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'jk_content',
            key:'jk_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"jk_bzd_danhao",
            key:'jk_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  
                        dsbzd_name={record.jk_bzd_name} 
                        dsbzd_id={record.jk_bzd_id} 
                        dsbzd_danhao={record.jk_bzd_danhao} 
                        yh_id={props.yh_id}  
                        yh_name={props.yh_name} 
                        qy_id={props.qy_id} 
                        qy_name={props.qy_name}
                        dsbzd_uid={record.jk_uid}
                    />
            }
        },      
        {
            title: '审批时间',
            dataIndex: 'jk_state_time',
            width: '10%',
            key: 'jk_state_time',             
        },
        {
            title: '状态',
            dataIndex: 'jk_state',
            width: '5%',
            key: 'jk_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_loan_list_submitted'
                    form={form}
                    initialValues={{                        
                        jk_state: query.jk_state ? query.jk_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            dsbzd_state: values.dsbzd_state ? values.dsbzd_state : '',
                            dsbzd_kh_id: values.dsbzd_kh_id ? values.dsbzd_kh_id : '',
                            dsbzd_content: values.dsbzd_content ? values.dsbzd_content : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(serializedValues.dsbzd_state));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_kh_id', JSON.stringify(serializedValues.dsbzd_kh_id));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_content', JSON.stringify(serializedValues.dsbzd_content));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    jk_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_loanList_jk_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={Number(props.loanRejectedNum)} style={{zIndex:'9999'}}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.loanEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>
                            
                        </Radio.Group>        
                    </Form.Item>                    
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_loanList_jk_state', JSON.stringify(''))
                                    setQuery({
                                        "jk_state": '',                                        
                                    })
                                    form.setFieldsValue({
                                        jk_content: null,
                                        jk_kh_id: null,
                                        jk_bzd_danhao: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#660099'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无借款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default LoanListSubmitted